import cx from 'classnames';
import { t } from 'i18next';
import { PossibleStreamTooltip } from '../../../../../../../shared/frontend/components/presentational/streamPreview';
import { namedRoutes, resolveRoutePath } from '../../../bundles/routes';
import { RecruitmentProfileBadge } from '../../../shared/recruitment/components/RecruitmentProfileBadge';
import { Link } from '../../../../../../../shared/frontend/components/link';
import type { TGuildCardProps } from './types';
import { formatRealmName } from './utils';

export function GuildCard(props: TGuildCardProps) {
  const { guild, streamers, recruitmentProfiles } = props;

  return (
    <div className="slds-tile slds-media">
      <div className="slds-media__body">
        <h3 className={cx({ 'streaming-now': streamers?.count > 0 })} title={guild.name}>
          <Link
            to={resolveRoutePath(namedRoutes.GuildDetails, {
              region: guild.region.slug,
              realm: guild.realm.slug,
              guild: guild.name
            })}
            className={`rio-faction-color--${guild.faction} slds-text-title--bold`}
          >
            <PossibleStreamTooltip stream={streamers?.stream} count={streamers?.count ?? 0}>
              {guild.displayName || guild.name}
            </PossibleStreamTooltip>
          </Link>

          {recruitmentProfiles && recruitmentProfiles.length > 0 && (
            <RecruitmentProfileBadge
              link={resolveRoutePath(namedRoutes.GuildRecruitmentPage, {
                region: guild.region.slug,
                realm: guild.realm.slug,
                guild: guild.name
              })}
              className={`rio-faction-color--${guild.faction} slds-text-title--bold slds-m-left--xx-small`}
              profile={recruitmentProfiles[0].recruitment_profile_id}
            />
          )}
        </h3>
        <div className="slds-tile__detail slds-text-body--small">
          <Link
            to={resolveRoutePath(namedRoutes.RegionHome, {
              region: guild.region.slug
            })}
            className="rio-realm-link"
          >
            ({t(`regions:${guild.region.slug}.short-name`)})
          </Link>{' '}
          <Link
            to={resolveRoutePath(namedRoutes.RealmHome, {
              region: guild.region.slug,
              realm: guild.realm.slug
            })}
            className="rio-realm-link"
          >
            {formatRealmName(guild.region, guild.realm)}
          </Link>
        </div>
      </div>
    </div>
  );
}
